export function HeroSection() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Hero Content */}
      <div className="container mx-auto px-4 sm:px-6 text-center relative z-10">
        <div className="max-w-6xl mx-auto space-y-6 sm:space-y-8">
          {/* Main Heading */}
          <h1 className="text-4xl sm:text-5xl md:text-7xl lg:text-8xl leading-tight">
            <span className="text-white font-light tracking-[0.15em] sm:tracking-[0.2em]" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              TEHK ZONE INC.
            </span>
          </h1>
          
          {/* Subheading */}
          <p className="text-lg sm:text-xl md:text-2xl text-gray-300 font-light tracking-wide max-w-3xl mx-auto leading-relaxed px-4">
            Bridging Creativity and Technology for Sustainable Business Growth
          </p>
          
          {/* Description */}
          <p className="text-sm sm:text-base md:text-lg text-gray-400 font-light max-w-2xl mx-auto leading-relaxed px-4">
            World-class marketing, media, and technology solutions that empower businesses to achieve growth, visibility, and measurable success
          </p>
          
          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 pt-6 sm:pt-8 px-4">
            <button 
              onClick={() => scrollToSection('products')}
              className="w-full sm:w-auto group relative bg-gradient-to-r from-violet-500 to-purple-500 text-white px-8 sm:px-10 py-3 sm:py-4 rounded-xl text-sm sm:text-base font-medium transition-all duration-300 hover:shadow-lg hover:shadow-purple-500/50 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <span className="relative z-10">Explore Our Services</span>
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="w-full sm:w-auto group relative bg-transparent border border-gray-600 text-white px-8 sm:px-10 py-3 sm:py-4 rounded-xl text-sm sm:text-base font-medium transition-all duration-300 hover:border-purple-400 hover:bg-purple-500/10 whitespace-nowrap cursor-pointer"
            >
              <span className="relative z-10">Get Started</span>
            </button>
          </div>
        </div>
      </div>
      
      {/* Scroll Indicator */}
      <div className="hidden sm:block absolute bottom-12 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-gray-600 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-gradient-to-b from-violet-400 to-purple-400 rounded-full"></div>
        </div>
      </div>
    </section>
  );
}